import cn from "classnames"

import style from "modules/NewClientSurvey/components/ProgressBar/style.module.scss"

interface Props {
    className?: string
    step: number
    count: number
}

export function ProgressBar({ className, count, step }: Props) {
    return (
        <div className={cn(style.container, className)}>
            <div className={style.list}>
                {Array.from(Array(count)).map((item, index) => {
                    return (
                        <div
                            className={cn(style.item, {
                                [style.isActive]: index + 1 <= step,
                            })}
                            key={index}
                        />
                    )
                })}
            </div>
        </div>
    )
}
